import { ReactNode } from "react";

interface PageHeaderProps {
  label?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}

export const PageHeader = ({ label, title, description, actions }: PageHeaderProps) => {
  return (
    <div className="ph">
      <div className="ph-l">
        {label && <span className="eyebrow">{label}</span>}
        <h1 className="t">{title}</h1>
        {description && <p className="ph-d">{description}</p>}
      </div>
      {actions && <div className="ph-a">{actions}</div>}
    </div>
  );
};

export default PageHeader;
